import React from "react";
import { useEffect } from "react";
import SelectPage from "../Comps/InsertData/SelectPage";
import CustomHeading from "../Comps/Extra/CustomHeading";
import { IoMdSave } from "react-icons/io";
const InsertData = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);
  // console.log("");
  return (
    <div className="m-2 text-center mt-12" style={{ minHeight: "90vh" }}>
      <CustomHeading
        text={{
          heading: "Insert Data",
          subText: "Database Management System",
        }}
        icon={IoMdSave}
        style={{
          height: "100px",

          // Main container
          width: "100%",
          borderRadius: "24px",
          shadow: "0 10px 30px rgba(0,0,0,0.15)",
          background: "#fff",

          // Gradient
          gradient: true,
          color: ["#063b87", "#0a57bb", "#087344"],
          gradientDirection: "120deg",

          // Heading
          headingColor: "#ffffff",
          headingSize: "clamp(2rem, 5vw, 3.5rem)",
          headingWidth: "520px",

          // Subtitle
          subtitleColor: "#f4f7fb",
          subtitleSize: "0.95rem",
          subtitleMaxWidth: "650px",
          subtitleLineHeight: 1.5,

          // Content
          contentGap: "4px",

          // Decorations
          showGlow: true,
          showRailway: true,
          decorationOpacity: 0.18,

          // Railway
          railwayWidth: "220px",
          railwayTop: "20px",
          railwayRight: "30px",
        }}
      />
      <div className=" ">
        <SelectPage />
      </div>
    </div>
  );
};
export default InsertData;
